import React, { useMemo } from 'react';
import { CircularProgress } from 'drift-ui';
import { Document, Page } from 'react-pdf';
import PdfErrorPanel from './PdfErrorPanel';
import styles from './PdfStateDocumentViewer.scss';

type PdfStateDocumentViewerProps = {
  fileData: Uint8Array | null;
  isLoading: boolean;
  hasError: boolean;
  numPages: number | null;
  onRefresh: () => void;
  onLoadSuccess: (numPages: number) => void;
  onLoadError: (error: Error) => void;
  pageKeyPrefix?: string;
  pageWidth?: number;
};

const PdfStateDocumentViewer: React.FC<PdfStateDocumentViewerProps> = ({
  fileData,
  isLoading,
  hasError,
  numPages,
  onRefresh,
  onLoadSuccess,
  onLoadError,
  pageKeyPrefix = 'page',
  pageWidth = 700,
}) => {
  const documentFile = useMemo(() => (fileData ? { data: fileData } : null), [fileData]);

  if (isLoading) {
    return (
      <div className={styles.pdfLoadingContainer}>
        <CircularProgress color="primary" size={40} thickness={4} />
      </div>
    );
  }

  if (hasError || !documentFile) {
    return <PdfErrorPanel onRefresh={onRefresh} />;
  }

  return (
    <Document
      file={documentFile}
      className={styles.pdfDocument}
      onLoadSuccess={({ numPages: loadedPages }) => {
        onLoadSuccess(loadedPages);
      }}
      onLoadError={onLoadError}
      style={{ border: 'solid 1px black' }}
    >
      {Boolean(numPages) &&
        Array.from(new Array(numPages), (_, index) => (
          <Page key={`${pageKeyPrefix}_${index + 1}`} pageNumber={index + 1} width={pageWidth} loading="" />
        ))}
    </Document>
  );
};

export default PdfStateDocumentViewer;
